import { render, staticRenderFns } from "./case.vue?vue&type=template&id=0ec736bd&scoped=true&"
import script from "./case.vue?vue&type=script&lang=js&"
export * from "./case.vue?vue&type=script&lang=js&"
import style0 from "./case.vue?vue&type=style&index=0&id=0ec736bd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ec736bd",
  null
  
)

export default component.exports